<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">
        <div>
            <h2>
                <b-form-select class="form-control input-larger-text" v-model="searchType" :options='searchTypeOptions' @change='loadTagsData'/>
                Draft Tags<span v-if='tagsList.length > 0'>, click to see drafts:</span>
                <span v-if='(isAuthenticated && searchType==="mytags" && (tagsList.length === 0))'>(you have not tagged any drafts yet).</span>
            </h2>
        </div>

        <div v-if='(searchType==="mytags" && !isAuthenticated)'>
            <h2>
            Please sign in to view drafts tagged by you.
            </h2>
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>
     
        <div v-if='((searchType==="mytags" && isAuthenticated) || searchType==="alltags")' class="vertical-padding">
            <div class='tag-box inline-auto-width' v-for='tag in tagsList' :key='tag.TagID'>
                <a :class='getTagCloudFontSizeClassForTag(tag)' :href='buildMatchingTagsCollectionUrl(tag.TagID, tag.TagName, searchType)'>{{tag.TagName}}</a>
            </div>
        </div>

        <helpUsButton/>
        <mailChimpSignup/>        
    </b-container>
</template>

<script>
/* eslint-disable handle-callback-err */
import urlsService from '../mixins/urlsService.js'
import dataService from '../mixins/dataService.js'
import utilityService from '../mixins/utilityService.js'
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import loginControl from './LoginControl.vue'

export default {
    mixins: [urlsService, dataService, utilityService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        loginControl: loginControl
    },
    data() {
        return {
            tagsList: [],
            UsageCount: 0,
            searchType: 'alltags',
            searchTypeOptions: [{ text: 'Your', value: 'mytags' }, { text: 'All', value: 'alltags' }],
            viewType: 'cloud',
            viewTypeOptions: [{ text: 'List', value: 'list' }, { text: 'Cloud', value: 'cloud' }]
        }
    },
    created() {
        // console.log('in created')
        this.$store.commit('setPageTitle', 'Weaving Draft and Documents Archive')
        this.searchType = this.$route.params.searchType
        this.loadTagsData()
    },
    methods: {
        loadTagsData() {
            this.resetSearchUrlParam()
            // console.log('in loadTagsData')
            let currentUserID = 0
            if (this.searchType ==='alltags') {
                currentUserID = 0
                this.$store.commit('setPageTitle', 'All Tagged Drafts')
                // console.log('about to get all tags all users')
                this.getAllTags(currentUserID).then(resp => {
                    // console.log(JSON.stringify(resp.data))
                    this.tagsList = resp.data.TagsList
                    this.UsageCount = resp.data.UsageCount
                })
            }
            else if (this.searchType==='mytags' && this.isAuthenticated) {
                // console.log('searchType == mytags')
                if (this.isAuthenticated) {
                    currentUserID = this.authUser.UserID
                    // console.log('authUser: ' + JSON.stringify(this.authUser))
                    // console.log('isAuthenticated, currentUserID: ' + currentUserID)
                }
                this.$store.commit('setPageTitle', 'Your Tagged Drafts')
                // console.log('about to get tags for user: ' + currentUserID)
                this.getAllTags(currentUserID).then(resp => {
                    // console.log(JSON.stringify(resp.data))
                    this.tagsList = resp.data.TagsList
                    this.UsageCount = resp.data.UsageCount
                })
            }
        },
        getTagCloudFontSizeClassForTag(tag) {
            if (tag.UsageCount < 2) {
                return 'size1'
            }
            else if (tag.UsageCount < 6) {
                return 'size2'
            }
            else if (tag.UsageCount < 11) {
                return 'size3'
            }
            else if (tag.UsageCount < 51) {
                return 'size4'
            }
            else if (tag.UsageCount < 101) {
                return 'size5'
            }
            else if (tag.UsageCount < 501) {
                return 'size6'
            }
            else if (tag.UsageCount < 1000) {
                return 'size7'
            }
            else {
                return 'size8'
            }
        },
        tagCollectionPageUrl: function(tagId, tagName) {
            return this.buildMatchingTagsCollectionUrl(tagId, tagName, this.searchType)
        },
        resetSearchUrlParam: function() {
            this.$router.replace({ params: { searchType: this.searchType } }).catch(err => {})
        }
    },

    watch: {
        'authUser.UserID': function(val) {
            this.loadTagsData()
        }
    },

    computed: {
        authUser: function() {
            return this.$store.state.authUser
        },
        authUserSettings: function() {
            return this.$store.state.authUserSettings
        },
        isAuthenticated: function() {
            let val=this.$store.getters.isAuthenticated
            // console.log('in isAuthenticated, returning ' + JSON.stringify(val))
            return val
        }
    }
}
</script>

<style scoped>

.padded-button {
    margin-right: 0.3rem;
    margin-bottom: 0.3rem;
    background-color: #f0f0f0;
}

.padded-button:hover {
    background-color: #dfdfdf;
}

.input-larger-text {
    font-size: 1.75rem;
    width: auto;
}

.size1 {
    font-size: 0.777rem
}

.size2 {
    font-size: 0.877rem
}

.size3 {
    font-size: 0.977rem
}

.size4 {
    font-size: 1.077rem
}

.size5 {
    font-size: 1.177rem
}

.size6 {
    font-size: 1.277rem
}

.size7 {
    font-size: 1.377rem
}

.size8 {
    font-size: 1.477rem
}

.tag-box {
    border: solid 1px;
    border-color: #cfcfcf;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 4px;
    margin-right: 0.5rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
}


</style>



// WEBPACK FOOTER //
// src/components/TagCloud.vue